import React from 'react';

// Components
import TargetsFromRequirements from './components/TargetsFromRequirements';
import TargetsFromRules from './components/TargetsFromRules';

// Types
import Locale from '@/types/locale';
import { RiskProfileConfigRequirements } from '@/types/risk-profiles/risk-profiles';
import { RiskProfileRule } from '@/types/risk-profiles';

interface RiskProfileTargetsProps {
  requirements?: RiskProfileConfigRequirements[];
  rules?: RiskProfileRule[];
  locale: Locale;
}

const RiskProfileTargets: React.FC<RiskProfileTargetsProps> = ({ requirements, rules, locale }) => {
  if (requirements?.length) {
    return <TargetsFromRequirements requirements={requirements} locale={locale} />;
  }

  if (rules?.length) {
    return <TargetsFromRules rules={rules} />;
  }

  return null;
};

export default RiskProfileTargets;
